import * as React from "react"

const Download = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <title>download</title>
    <path d="M19,12v7H5V12H3v7a2.00588,2.00588,0,0,0,2,2H19a2.00588,2.00588,0,0,0,2-2V12Zm-6,.67,2.59-2.58L17,11.5l-5,5-5-5,1.41-1.41L11,12.67V3h2Z" />
  </svg>
)

export default Download
